import React, { forwardRef, useImperativeHandle } from 'react';
import { useListBigQueryRoutineArguments } from '../../../../query/acg/phase-1';
import { Spin } from 'antd';
import { BQRoutineArgumentConfig } from './types';
import {
  useForm,
  FormProvider,
  Controller,
  useFormContext,
} from 'react-hook-form';
import useDeepCompareEffect from 'react-use/lib/useDeepCompareEffect';
import {
  getArgumentsConfigAsObject,
  getFieldNameFromDataType,
  getValueFromArgumentConfig,
} from './utils';
import _ from 'lodash';
import BQArgumentsInputRenderer from './components/BQArgumentsInputRenderer';

type Props = {
  routineName: string,
};

export default forwardRef(ManageDefaultValueModalContent);

function ManageDefaultValueModalContent(props: Props, ref) {
  const { data, isLoading } = useListBigQueryRoutineArguments(
    props.routineName,
  );
  const form = useForm();
  useDeepCompareEffect(() => {
    form.reset(getArgumentsConfigAsObject(data));
  }, [data]);
  useImperativeHandle(ref, () => ({
    getUpdatedValues: () => {
      const updatedValue = [];
      const values = form.getValues();
      data.forEach(config => {
        if (
          !_.isEqual(
            getValueFromArgumentConfig(config),
            values[config.argumentName],
          )
        ) {
          updatedValue.push({
            argumentName: config.argumentName,
            [getFieldNameFromDataType(config.dataType)]: values[
              config.argumentName
            ],
          });
        }
      });
      return updatedValue;
    },
  }));
  return (
    <Spin spinning={isLoading}>
      <FormProvider {...form}>
        <div className="space-y-4">
          {data?.map(config => (
            <RenderField config={config} key={config.argumentName} />
          ))}
        </div>
      </FormProvider>
    </Spin>
  );
}

function RenderField(props: { config: BQRoutineArgumentConfig }) {
  const { config } = props;
  const form = useFormContext();
  return (
    <Controller
      control={form.control}
      name={config.argumentName}
      render={({ field: { onChange, value, onBlur } }) => {
        return (
          <div className="space-y-2">
            <p className="input-name" style={{ marginBottom: 0 }}>
              {config.argumentName}
            </p>
            <BQArgumentsInputRenderer
              dataType={config.dataType}
              placeholder={`Default value for ${config.argumentName}`}
              selectOptions={config.defaultSelectOptions}
              value={value}
              onBlur={onBlur}
              onChange={onChange}
            />
          </div>
        );
      }}
    />
  );
}
